import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useConfirmationAction } from '../../../../hooks/confirmation-action.hook';
import { useMutationMarkOrderCollected } from '../../order-details.queries';
import { KnownOrderDtoStatus, OrderDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { mapHubToDeliveryContainerLabel } from '../order-details.utils';
import { useIsRetailFlow } from '../../../list/actions/book-order/use-booking-flow-type.hook';

export function MarkCollectedModal({
  order,
  onAbort,
  onSuccess
}: {
  order: OrderDto;
  onAbort(): void;
  onSuccess(): void;
}) {
  const { state, onConfirm } = useConfirmationAction({
    mutationHook: useMutationMarkOrderCollected,
    mutationArgs: { retailerID: order.retailer.id, orderID: order.id },
    onSuccess,
    modalCloseDelay: 300
  });
  const isRetailFlow = useIsRetailFlow(order.retailer.id);

  return (
    <ConfirmationModal
      title="Mark Collected?"
      content={makeModalContent(order, isRetailFlow)}
      actionButton={{
        color: 'primary',
        label: 'Mark Collected'
      }}
      cancelButton={{
        label: 'No'
      }}
      onConfirm={onConfirm}
      onCancel={onAbort}
      {...state}
    />
  );
}

function makeModalContent(order: OrderDto, isRetailFlow: boolean): string[] {
  const content = [`Marking the order Collected is for when you've removed the order and given it to the customer.`];
  const deliveryContainerLabel = mapHubToDeliveryContainerLabel(order.hub);

  if (assertIsIntermediateState(order.status)) {
    content[0] += ` We'll update the ${deliveryContainerLabel} state to reflect that it is now empty and the customer's collection code will no longer work.`;
    if (isRetailFlow) {
      content.push(
        `If you've taken it back, you should mark the order as Retrieved instead, or if it was delivered in error Cancelled.`
      );
    }
  }

  content.push(`Are you sure?`);

  return content;
}

function assertIsIntermediateState(status: string) {
  return [KnownOrderDtoStatus.Delivered, KnownOrderDtoStatus.Overdue, KnownOrderDtoStatus.RetrievalRequired].includes(
    status as KnownOrderDtoStatus
  );
}
